var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_580_258)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5002 31.6484C35.9955 31.6484 35.4915 31.8944 35.2533 32.3866L27.5768 48.2503C27.0994 49.2371 28.0973 50.4452 29.1565 50.1627L35.9399 48.3536C36.3069 48.2556 36.6935 48.2556 37.0606 48.3536L43.844 50.1627C44.9031 50.4452 45.9011 49.2371 45.4236 48.2503L37.7471 32.3866C37.509 31.8944 37.005 31.6484 36.5002 31.6484Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.521 22.792C34.1807 22.792 33.0731 23.8996 33.0731 25.2399H20.6633C20.2563 24.1037 19.1644 23.2816 17.896 23.2816C16.2853 23.2816 14.9585 24.6083 14.9585 26.2191C14.9585 27.8298 16.2853 29.1566 17.896 29.1566C19.1644 29.1566 20.2563 28.3345 20.6633 27.1982H28.925C24.3707 29.7213 21.2071 34.4452 20.8679 39.9274H20.8335C19.4932 39.9274 18.3856 41.035 18.3856 42.3753V44.3337C18.3856 45.674 19.4932 46.7816 20.8335 46.7816H22.7918C24.1322 46.7816 25.2397 45.674 25.2397 44.3337V42.3753C25.2397 41.0479 24.153 39.9504 22.8301 39.9293C23.2502 33.9562 27.4847 29.0544 33.1113 27.6247C33.3162 28.7657 34.3259 29.6462 35.521 29.6462H37.4793C38.6744 29.6462 39.6841 28.7657 39.889 27.6247C45.5157 29.0544 49.7501 33.9562 50.1703 39.9293C48.8473 39.9504 47.7606 41.0479 47.7606 42.3753V44.3337C47.7606 45.674 48.8682 46.7816 50.2085 46.7816H52.1668C53.5072 46.7816 54.6147 45.674 54.6147 44.3337V42.3753C54.6147 41.035 53.5072 39.9274 52.1668 39.9274H52.1324C51.7933 34.4452 48.6297 29.7213 44.0753 27.1982H52.337C52.7441 28.3345 53.836 29.1566 55.1043 29.1566C56.7151 29.1566 58.0418 27.8298 58.0418 26.2191C58.0418 24.6083 56.7151 23.2816 55.1043 23.2816C53.836 23.2816 52.7441 24.1037 52.337 25.2399H39.9272C39.9272 23.8996 38.8197 22.792 37.4793 22.792H35.521ZM35.521 24.7503H37.4793C37.7613 24.7503 37.9689 24.9579 37.9689 25.2399V27.1982C37.9689 27.4802 37.7613 27.6878 37.4793 27.6878H35.521C35.239 27.6878 35.0314 27.4802 35.0314 27.1982V25.2399C35.0314 24.9579 35.239 24.7503 35.521 24.7503Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_258",
    x1: 3.5,
    y1: 3,
    x2: 70,
    y2: 70.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.9e9496a0d4c78f8f87cd6c1307d66844.svg";
export { ForwardRef as ReactComponent };